var _circle, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _polygon, _path2, _path3, _polygon2, _path4, _polygon3, _polygon4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 650 512",
    id: "empty-box",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 337.969,
    cy: 256,
    r: 167.695,
    fill: "#dbe8ec"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M564.58343,220.90338V202.7937a13.02087,13.02087,0,0,0-13.02086-13.02087H505.60333A13.02086,13.02086,0,0,1,492.58247,176.752V158.64229a13.02087,13.02087,0,0,1,13.02086-13.02087h1.45112a13.02087,13.02087,0,0,0,13.02086-13.02087V114.49087A13.02087,13.02087,0,0,0,507.05445,101.47H173.13523a13.02087,13.02087,0,0,0-13.02087,13.02087v18.10968a13.02087,13.02087,0,0,0,13.02087,13.02087h0a13.02087,13.02087,0,0,1,13.02086,13.02087V176.752a13.02086,13.02086,0,0,1-13.02086,13.02086H122.7824a13.02087,13.02087,0,0,0-13.02087,13.02087v18.10968a13.02087,13.02087,0,0,0,13.02087,13.02087h19.75769A13.02087,13.02087,0,0,1,155.561,246.94512v18.10976a13.02087,13.02087,0,0,1-13.02086,13.02087h-.04775a13.02087,13.02087,0,0,0-13.02087,13.02087v18.10959a13.02087,13.02087,0,0,0,13.02087,13.02087h2.85852A13.02087,13.02087,0,0,1,158.37173,335.248v18.10976a13.02087,13.02087,0,0,1-13.02087,13.02087H98.43743a13.02087,13.02087,0,0,0-13.02086,13.02087v18.10968A13.02087,13.02087,0,0,0,98.43743,410.53H514.045a13.02087,13.02087,0,0,0,13.02087-13.02087V379.39945A13.02087,13.02087,0,0,0,514.045,366.37858H502.75526a13.02087,13.02087,0,0,1-13.02087-13.02087V335.248a13.02087,13.02087,0,0,1,13.02087-13.02087h26.62008a13.02087,13.02087,0,0,0,13.02087-13.02087V291.09662a13.02087,13.02087,0,0,0-13.02087-13.02087h-8.07529a13.02087,13.02087,0,0,1-13.02087-13.02087V246.94512a13.02087,13.02087,0,0,1,13.02087-13.02087h30.26252A13.02087,13.02087,0,0,0,564.58343,220.90338Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 384.775,
    x2: 417.077,
    y1: 92.159,
    y2: 92.159,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 384.775,
    x2: 417.077,
    y1: 101.47,
    y2: 101.47,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 384.775,
    x2: 417.077,
    y1: 110.781,
    y2: 110.781,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 119.153,
    x2: 151.456,
    y1: 289.908,
    y2: 289.908,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 119.153,
    x2: 151.456,
    y1: 299.218,
    y2: 299.218,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 119.153,
    x2: 151.456,
    y1: 308.529,
    y2: 308.529,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 505.663,
    x2: 537.966,
    y1: 375.236,
    y2: 375.236,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 505.663,
    x2: 537.966,
    y1: 384.546,
    y2: 384.546,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 505.663,
    x2: 537.966,
    y1: 393.857,
    y2: 393.857,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.78,
    cy: 202.347,
    r: 13.807,
    fill: "#b9d4db"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.344,
    cy: 212.312,
    r: 7.159,
    fill: "#b9d4db"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.523,
    cy: 168.562,
    r: 10.228,
    fill: "#b9d4db"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.38,
    cy: 389.402,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.897,
    cy: 397.598,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.847,
    cy: 369.192,
    r: 4.936,
    fill: "#b9d4db"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.321,
    cy: 356.549,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.43,
    cy: 135.463,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.096,
    cy: 101.968,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.091,
    cy: 106.968,
    r: 7.406,
    fill: "#b9d4db"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.147,
    cy: 99.771,
    r: 4.936,
    fill: "#b9d4db"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.883,
    cy: 126.713,
    r: 11.833,
    fill: "#b9d4db"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e06714",
    points: "483.963 291.561 374.753 350.388 374.753 216.949 483.963 182.855 483.963 291.561"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9ae2b",
    d: "M374.7531,216.94926l-128.92075-13.042-26.42178-38.98094a3,3,0,0,1,2.4833-4.68321H343.33871a3,3,0,0,1,2.65955,1.61192Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9ae2b",
    d: "M245.83235 337.34632L200.80822 327.978a3 3 0 01-2.38887-2.93709V197.73033a3 3 0 013.61113-2.93709l43.80187 9.114zM418.21848 364.85872L374.7531 350.38835V216.94926l45.36062 15.10133a3 3 0 012.05238 2.84641V362.01231A3 3 0 01418.21848 364.85872z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#409cb5",
    points: "374.753 350.388 245.832 337.346 245.832 203.907 374.753 216.949 374.753 350.388"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9ae2b",
    d: "M341.97,386.09125l-131.54367-5.24868,35.406-43.49625,128.92075,13.042-30.40766,34.683A3,3,0,0,1,341.97,386.09125Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ee781d",
    points: "374.753 216.949 483.963 182.855 350.473 170.429 374.753 216.949"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#25788e",
    points: "245.832 337.346 374.753 277.148 374.753 216.949 245.832 203.907 245.832 337.346"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M253.56224,293.86279s14.0847-6.16206,17.826-1.76059,12.104,6.38213,12.104,6.38213l7.26242-12.32411,19.80661,9.24308,10.7836,14.74492-7.04235,17.3858s-14.30477-.22007-21.127,2.64088-24.64822,3.081-24.64822,3.081l-8.14272-15.62521S250.04107,302.44565,253.56224,293.86279Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad5db",
    d: "M283.49223,298.48431c1.35456,1.20007,2.65566,2.445,3.93082,3.71143,1.286,1.25744,2.52385,2.555,3.76631,3.84887,1.21591,1.316,2.46431,2.60486,3.64342,3.95166,1.18951,1.338,2.40047,2.65821,3.5498,4.02991l-2.53526,1.254c-.575-2.39258-1.14255-4.78687-1.65111-7.19458-.51942-2.40515-.96371-4.82727-1.42943-7.24463-.84754-4.85364-1.638-9.72009-2.01213-14.68079,1.79647,4.639,3.17659,9.3722,4.49964,14.11829.61958,2.38257,1.26059,4.76025,1.82646,7.15491.57672,2.39221,1.0945,4.79785,1.60478,7.20508l.0044.02075a1.45451,1.45451,0,0,1-2.53975,1.2334c-1.14635-1.37427-2.2311-2.79993-3.33728-4.20764-1.11658-1.399-2.16387-2.85608-3.24366-4.28589-1.05322-1.452-2.111-2.90027-3.12075-4.38868C285.428,301.53106,284.43336,300.03009,283.49223,298.48431Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad5db",
    d: "M310.56126,295.40326c-.84011,1.81176-1.78526,3.55212-2.72747,5.29443-.9668,1.72559-1.9399,3.4469-2.96647,5.13184-.99682,1.7052-2.06942,3.35888-3.11573,5.03039-1.05454,1.6659-2.16841,3.29151-3.2497,4.93933l-1.52806-2.30468c2.00444-.4115,4.0164-.78516,6.03165-1.14246,2.02347-.31616,4.03494-.69226,6.06828-.95911,2.02654-.30078,4.06415-.546,6.10492-.77563,2.04791-.19385,4.09282-.40271,6.16618-.46912-1.93969.73535-3.90785,1.32837-5.873,1.9364-1.97229.57239-3.94773,1.12891-5.93424,1.63-1.97972.535-3.9813.96069-5.97087,1.44653-1.99782.44446-3.9989.87268-6.00752,1.26306l-.03152.00623a1.484,1.484,0,0,1-1.49662-2.311c1.13451-1.61157,2.23642-3.24524,3.39769-4.83862,1.16947-1.58789,2.31267-3.19348,3.53163-4.74768,1.18924-1.57434,2.43193-3.11243,3.68093-4.64612C307.91493,298.36993,309.18558,296.85089,310.56126,295.40326Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad5db",
    d: "M314.30251,327.534c-1.62475-.77-3.16161-1.65905-4.70708-2.53649-1.52558-.90442-3.03768-1.827-4.519-2.79151-2.98088-1.90393-5.86587-3.93786-8.69781-6.04358l2.16636-.428c-1.71183,2.7898-3.486,5.54187-5.38934,8.2157-.93138,1.34925-1.92,2.6637-2.91315,3.97559-1.01684,1.29736-2.03357,2.59485-3.15448,3.82922.5755-1.56494,1.25516-3.06665,1.9347-4.56848.70329-1.48743,1.411-2.97217,2.176-4.42224,1.48944-2.92456,3.108-5.771,4.789-8.57959a1.4876,1.4876,0,0,1,2.04048-.51245l.1133.075.01284.00952c2.84673,2.08569,5.6404,4.24329,8.33817,6.53088,1.358,1.13135,2.68527,2.30445,3.999,3.49585C311.78546,325.00165,313.08792,326.20831,314.30251,327.534Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad5db",
    d: "M253.56224,293.86273c7.6031,2.8551,15.01918,6.09766,22.40817,9.39624,3.67754,1.68445,7.36335,3.35181,11.00716,5.1062,3.66327,1.714,7.29237,3.49878,10.91981,5.287l.01108.00549a1.45144,1.45144,0,0,1,.13747,2.52637c-2.39525,1.52417-4.8407,2.96948-7.26143,4.45373-2.41635,1.491-4.88512,2.89978-7.32512,4.35364-2.464,1.41626-4.91716,2.84949-7.4102,4.22q-3.7221,2.08338-7.52194,4.04456,3.38175-2.61786,6.84762-5.10364c2.29682-1.67883,4.63346-3.29517,6.95935-4.92822,2.34986-1.59546,4.671-3.23621,7.04444-4.79456,2.36912-1.56531,4.71353-3.16931,7.10815-4.69446l.14851,2.53162c-3.65657-1.72791-7.31149-3.45923-10.93223-5.26123-3.6402-1.76184-7.23842-3.6106-10.8449-5.44226C267.67914,301.82953,260.52719,298.03985,253.56224,293.86273Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad5db",
    d: "M259.48534 316.22491a43.29962 43.29962 0 007.38432-3.62451 14.86708 14.86708 0 005.2729-5.28943 12.24264 12.24264 0 001.143-7.2229 42.46343 42.46343 0 00-1.8974-7.98584 18.61237 18.61237 0 014.21374 7.5398 12.25 12.25 0 01-.81392 9.08166 13.85452 13.85452 0 01-6.821 5.95569A18.88134 18.88134 0 01259.48534 316.22491zM281.97833 307.57965a33.23523 33.23523 0 01-1.05427 6.06726 56.0831 56.0831 0 01-1.84972 5.764 55.10811 55.10811 0 01-2.45172 5.53467 32.83451 32.83451 0 01-3.25476 5.22863 32.82892 32.82892 0 011.05047-6.06872 55.09358 55.09358 0 011.85352-5.76258 56.065 56.065 0 012.45552-5.5332A33.23322 33.23322 0 01281.97833 307.57965z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0d8dd",
    d: "M252.83119,366.41465s-10.72928,11.01055-15.85215,8.34108-13.61613-1.35658-13.61613-1.35658l-2.08928,14.15138-21.8291-1.10774-15.54069-9.60132-.01991-18.75794s13.33551-5.18066,18.5791-10.39921,21.67562-12.13241,21.67562-12.13241l13.4254,11.41094S252.86266,357.13763,252.83119,366.41465Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc6cc",
    d: "M223.36291,373.39911c-3.32586-1.36841-6.57566-2.88-9.81163-4.41761-1.608-.78772-3.2292-1.55041-4.82216-2.36621-1.59721-.808-3.20315-1.59936-4.784-2.43811l1.25115-1.41076c2.86248,4.00329,5.6272,8.0747,8.33829,12.18335,2.67887,4.13122,5.32571,8.28466,7.739,12.6007-3.21111-3.76049-6.18869-7.68359-9.13426-11.629-2.91333-3.9679-5.77305-7.97315-8.535-12.04651l-.00719-.0105a.96977.96977,0,0,1,1.2584-1.40027c1.5796.84106,3.13408,1.72925,4.6973,2.6012,1.56746.86377,3.10666,1.78088,4.65912,2.673C217.29687,369.56024,220.36792,371.40814,223.36291,373.39911Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc6cc",
    d: "M199.44453,386.44281c.42849-3.93885,1.0458-7.83728,1.72633-11.72217.66993-3.88709,1.44936-7.75073,2.25562-11.60864l1.52211,1.03991L199.8019,367.498c-1.73979,1.07849-3.45707,2.19129-5.21533,3.24182-1.74554,1.06983-3.51181,2.10828-5.284,3.13782-1.78553,1.00928-3.5656,2.02674-5.39875,2.96387,1.5829-1.31641,3.2189-2.55237,4.84943-3.79663,1.64389-1.22388,3.29367-2.439,4.9642-3.62256,1.6578-1.20288,3.35657-2.34363,5.03284-3.51843l5.1015-3.41455a.99324.99324,0,0,1,1.52223,1.04c-.84564,3.84948-1.71813,7.69323-2.70011,11.51342C201.70256,378.86529,200.668,382.67425,199.44453,386.44281Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc6cc",
    d: "M183.88393,358.08355c1.76662.21338,3.50887.52222,5.25348.8219,1.73909.32117,3.47444.65711,5.20124,1.02649,3.45707.7251,6.8891,1.54847,10.30727,2.426l-1.22664.8053c.28153-1.61231.53048-3.22986.83875-4.83789.305-1.60865.59732-3.21924.943-4.82129.66589-3.20813,1.39248-6.40662,2.307-9.575-.12141,3.29541-.43072,6.56079-.80072,9.8164-.17228,1.62976-.39787,3.2511-.61085,4.87439-.20968,1.6239-.47867,3.23828-.71509,4.85779a.98116.98116,0,0,1-1.11255.8291l-.09845-.01941-.01587-.00415c-3.42058-.86816-6.8273-1.79053-10.209-2.811-1.69259-.50342-3.3766-1.04041-5.05689-1.592C187.21382,359.30694,185.53669,358.743,183.88393,358.08355Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc6cc",
    d: "M252.83119,366.41461c-4.05163-.0116-8.09672-.12549-12.14261-.22717-4.04475-.11914-8.08612-.29139-12.12717-.46875q-12.11989-.58264-24.22273-1.43225l-.00726-.00061a.96771.96771,0,0,1-.71985-1.526c1.64518-2.31384,3.34115-4.59155,5.01212-6.887,1.66654-2.2987,3.38612-4.55957,5.07657-6.84131,1.71733-2.26245,3.4127-4.54065,5.16852-6.77575,1.75149-2.23829,3.47378-4.49732,5.26987-6.70386-1.49363,2.42151-3.06106,4.79065-4.59929,7.18042-1.5339,2.39294-3.12824,4.74292-4.70064,7.10852-1.59926,2.34643-3.1694,4.71362-4.79258,7.04309-1.61875,2.33252-3.21249,4.683-4.857,6.99719l-.727-1.52637q12.1134.68445,24.20808,1.66175c4.03075.33838,8.06119.68188,12.08822,1.07837C244.78431,365.50885,248.811,365.9107,252.83119,366.41461Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc6cc",
    d: "M238.92628 347.92682a36.16435 36.16435 0 00-5.78154 5.88134 14.52208 14.52208 0 00-3.0868 7.08912 10.01 10.01 0 00.30765 3.77978 13.7163 13.7163 0 001.5149 3.61182 35.60761 35.60761 0 005.09855 6.46679 20.25478 20.25478 0 01-6.40727-5.61657 12.22052 12.22052 0 01-2.50172-8.45044 13.96415 13.96415 0 013.88476-7.88111A20.51472 20.51472 0 01238.92628 347.92682zM221.34183 364.40289a46.84482 46.84482 0 01-.90911-6.02649c-.19024-2.01123-.31187-4.024-.35424-6.03857-.04927-2.01441-.01363-4.03064.08736-6.04822a46.32941 46.32941 0 01.64822-6.06055 46.326 46.326 0 01.91211 6.02649c.189 2.01123.31256 4.024.35124 6.03858.0456 2.01452.01192 4.03064-.09035 6.04834A46.84562 46.84562 0 01221.34183 364.40289z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.fa0c1d76b0e9d88e871cebad0aa4f3c5.svg";
export { ForwardRef as ReactComponent };